import "./Wishlist.module.css";
import Header from "@/reusable_sections/Header";
import Wishlist from "./sections/Wishlist";
import Footer from "@/reusable_sections/Footer";
export default function WishlistPage() {
  return <div>
      <Header />
      <Wishlist />
      <Footer />
    </div>;
}